export const SCORES_ESTIMATE = "SCORES_ESTIMATE"
export const SCORES_AVG = "SCORES_AVG"
export const HELLO_TEST = "HELLO_TEST"

